import {CultivosActions, CultivosActionTypes} from './cultivos.actions';
import {cultivosAdapter, CultivosState, initialState} from './cultivos.state';

export function cultivosReducer(
  state = initialState,
  action: CultivosActions
): CultivosState {
  switch (action.type) {
    // load
    case CultivosActionTypes.CULTIVOS_LOAD_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null
      };
    }
    case CultivosActionTypes.CULTIVOS_LOAD_SUCCESS: {
      return cultivosAdapter.addMany(action.payload.items, {
        ...state,
        isLoading: false,
        error: null
      });
    }
    case CultivosActionTypes.CULTIVOS_LOAD_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    // default
    default: {
      return state;
    }
  }
}
